// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable i18next/no-literal-string */
import { getCurrentUser as getAsyncCurrentUser } from '@lastbrand/fe-common/universal-auth'

import { checkIfGtmIsBlocked } from '@src/quince-site-common/src/utils/checkIsGtmBlocked'
import initialiseDlProxy from '@src/quince-site-common/src/utils/dataLayer.utils'
import { hydrateWaitlistPhoneFromMeta } from '@src/quince-site-common/src/utils/join-waitlist-phone-storage'
import {
  validateLbUserId,
  validateSessionId,
  executeOnceIfSessionIsNew,
} from '@src/telemetry/integrations/provider-utils/internal-analytics-utils'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { isAdvertisingConsentRequired } from '@src/telemetry/telemetry-registry'
import { initializeTelemetry, trackInternalEvent } from '@src/telemetry/track'
import { removeAndSetNewCookies } from '@src/utils/auth.utils'
import { getCookieStorage } from '@src/utils/enhancedCookie'

import mixpanelCl from '../../../telemetry/integrations/mixpanel'
import { ANALYTIC_COOKIES } from '../utils/constants'
import initUserAnalyticsCookie from '../utils/init-user-analytics-cookie'

export default function initialize({ enableTelemetry }: { enableTelemetry: boolean }) {
  // Capturing user information in cookie.
  setCustomerDetailsInCookie().catch((error: unknown) => {
    console.error('Failed to set customer details in cookie', error)
  })

  // Persisting Session information in cookies.
  validateLbUserId()
  validateSessionId()

  initUserAnalyticsCookie()

  initialiseDlProxy()
  // Skip GTM reachability check for UK pre-consent — making any network request
  // to a 3P domain before advertising consent is a GDPR violation.
  if (!isAdvertisingConsentRequired()) {
    checkIfGtmIsBlocked()
  }
  if (enableTelemetry) {
    initializeTelemetry()
  }

  executeOnceIfSessionIsNew(({ sessionId, lastSessionId }) => {
    trackInternalEvent(TELEMETRY_EVENT_NAMES.SESSION_CREATE, {
      sessionId: sessionId,
      lastSessionId,
    })
  })
}

async function setCustomerDetailsInCookie() {
  const user = await getAsyncCurrentUser()
  if (user?.email) {
    // A logged-in customer's email is persisted for all locales (incl. UK), same as
    // US/CA. It is erased on logout, so for UK it only exists while logged in.
    removeAndSetNewCookies(ANALYTIC_COOKIES.LB_CUSTOMER_EMAIL, user.email)
    mixpanelCl.identify({ email: user.email, isTentativeEmail: false })
  }
  if (user?.customerMetadata?.customerId) {
    removeAndSetNewCookies(ANALYTIC_COOKIES.LB_CUSTOMER_ID, user.customerMetadata.customerId)
  } else if (user?.email) {
    getCookieStorage().removeCookieLocalized(ANALYTIC_COOKIES.LB_CUSTOMER_ID, { isGlobal: true })
  }
  hydrateWaitlistPhoneFromMeta(user?.customerMetadata)
}
